var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('MasterHeader'),_c('MasterMenu'),_c('MasterBody'),_c('MasterFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }